import { css } from '@emotion/react';

import { theme } from '../theme';

const expandedPaddingTop = theme.spacing.values.xxl;

export const wrapper = (isExpanded: boolean) => css`
  width: 100%;
  min-height: 72px;
  background-color: ${theme.colors.white};
  padding: ${isExpanded ? `${theme.spacing.values.lg + expandedPaddingTop}rem` : theme.spacing.lg} 0 ${theme.spacing.lg};
  font-size: ${theme.fontSize.sm};

  @media (max-width: ${theme.breakpoints.laptop}) {
    padding: ${theme.spacing.md} 0;
  }
`;

export const content = css`
  display: flex;
  gap: ${theme.spacing.lg};
  flex-direction: column;
`;

export const row = (isExpanded: boolean = false) => css`
  display: flex;
  gap: ${theme.spacing.xxxl};
  align-items: center;

  @media (max-width: ${theme.breakpoints.laptop}) {
    flex-direction: column;
    align-items: start;
    gap: ${isExpanded ? theme.spacing.lg : 0};
  }
`;

export const rowSection = css`
  display: flex;
  gap: ${theme.spacing.xxxl};
  align-items: center;

  @media (max-width: ${theme.breakpoints.laptop}) {
    gap: ${theme.spacing.xs};
  }
`;

export const toggler = (isExpanded: boolean) => css`
  position: absolute;
  top: ${isExpanded ? `-${expandedPaddingTop}rem` : 0};
  right: ${theme.spacing.md};
  display: flex;
  gap: ${theme.spacing.xs};
  text-decoration: underline;
  cursor: pointer;
  align-items: center;
  color: ${theme.colors.link};

  &:hover {
    color: ${theme.colors.linkHover};
  }

  &:focus {
    color: ${theme.colors.link};
  }

  svg {
    color: ${theme.colors.gray[4]};
    transform: rotate(${isExpanded ? '180deg' : 0});
    transition: none;
  }

  @media (max-width: ${theme.breakpoints.laptop}) {
    top: 0;
    font-size: 14px;
  }
`;

export const togglerArrow = css`
  @media (max-width: ${theme.breakpoints.laptop}) {
    display: none;
  }
`;

export const actions = css`
  min-width: 60px;
`;

export const form = css`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  gap: ${theme.spacing.lg};
  align-items: center;

  @media (max-width: ${theme.breakpoints.laptop}) {
    flex-direction: column;
    align-items: start;
  }
`;

export const submitButton = css`
  margin-left: auto;

  @media (max-width: ${theme.breakpoints.laptop}) {
    width: 100%;
  }
`;
